<template>
  <form
    enctype="multipart/form-data"
    method="post"
    id="product_form"
    accept-charset="UTF-8"
    @submit="formSubmit"
    action="/cart/add"
    ref="form"
  >
    <client-only>
      <ProductSameDesign v-if="showSameDesign"></ProductSameDesign>
      <template #placeholder>
        <div
          v-if="showSameDesign"
          class="product__same-design product__same-design--placeholder"
        ></div>
      </template>
    </client-only>
    <client-only>
    <input
      type="hidden"
      v-if="
        discountStore.campaignDiscountCode &&
        !hasFakePriceBF9ButNoDiscountProductTag
      "
      :name="`properties[${CAMPAIGN_DISCOUNT_LINE_ITEM_ATTRIBUTE_KEY}]`"
      :value="discountStore.campaignDiscountCode"
    />

    <input
      type="hidden"
      v-if="discountStore.tagDiscountCode && isDefaultVariant"
      :name="`properties[${DEFAULT_PRICE_TAG_DISCOUNT_LINE_ITEM_ATTRIBUTE_KEY}]`"
      :value="firstProductVariantPriceTagDiscountCode"
    />

    <template v-if="firstUTM">
      <input
        type="hidden"
        :name="`properties[${FIRST_UTM_LINE_ITEM_ATTRIBUTE_KEY_PREFIX}id]`"
        :value="firstUTM.id"
      />
    </template>

    <template v-if="lastUTM">
      <input
        type="hidden"
        :name="`properties[${LAST_UTM_LINE_ITEM_ATTRIBUTE_KEY_PREFIX}id]`"
        :value="lastUTM.id"
      />
    </template>

    <template v-if="assignedABTest">
      <input
        type="hidden"
        :name="`properties[${AB_TEST_LINE_ITEM_ATTRIBUTE_KEY}]`"
        :value="assignedABTest"
      />
    </template>

    <template v-if="isDigitalContentProductType">
      <input
        type="hidden"
        :name="`properties[_qr-greeting-card-item-id]`"
        :value="qrGreetingCardItemIdBundle"
      />
    </template>

    <template v-if="product?.handle">
      <input
        type="hidden"
        :name="`properties[_cp-truncated-variant-sku]`"
        :value="isTruncatedVariantSKU"
      />
    </template>

    <template v-if="firstProductVariant">
      <input
        type="hidden"
        :name="`properties[_first-product-variant]`"
        :value="firstProductVariant"
      />
    </template>

    <!-- use it to update product id tracking in custom event  -->
    <input
      type="hidden"
      :name="`properties[_tag_${PRODUCT_TAG_GOOGLE_DUP_KW}]`"
      :value="
        isProductHasTags(productStore.product, [PRODUCT_TAG_GOOGLE_DUP_KW])
      "
    />

    <input
      type="hidden"
      :name="`properties[_ship-from]`"
      :value="
        productStore.selectedShippedOption ||
        productStore.productShipping?.ship_from ||
        SHIP_FROM_OVERSEAS
      "
    />

    </client-only>

    <div class="product__option-extra" v-if="productOptionsExtra">
      <h2>{{ productOptionsExtra?.optionTitle }}</h2>
      <div class="product__option-choices">
        <template v-for="(item, i) in productOptionsExtra?.Options" :key="i">
          <sib-link
            v-if="item.link && !item?.link?.includes(productStore?.product?.handle)"
            :to="item.link"
            :title="item.name">
            <span class="product__option-choice"  :class="{ 'product__option-choice--actived': item?.link?.includes(productStore?.product?.handle)}">{{  item.name }}</span>
          </sib-link>
          <span v-else class="product__option-choice" :class="{ 'product__option-choice--actived': item?.link?.includes(productStore?.product?.handle) || productStore?.product?.handle?.includes(productOptionsExtra.handle)}">{{ item.name }}</span>
        </template>
      </div>
    </div>

      <LeverSphereProductOptions v-if="isLeverSphereCustomizer"></LeverSphereProductOptions>
      <ProductOptions v-else></ProductOptions>

    <div class="product__option-extra" v-if="productOptionsAI && !isProductHasTags(productStore.product, ['AI_multi_pose'])">
      <h2>{{ productOptionsAI?.optionTitle }}</h2>
      <div class="product__option-choices">
        <template v-if="isLoading">
          <sib-skeleton-loading v-for="n in 2" :key="n" width="7em" height="2em"></sib-skeleton-loading>
        </template>
        <template v-else v-for="(item, i) in productOptionsAI?.options" :key="i">
          <span class="product__option-choice"
          @click="fetchCustomizationTemplatesByCode(item.template)"
          :class="{ 'product__option-choice--actived': customizationStore.customizationTemplates?.length && customizationStore.customizationTemplates[0]?.code?.includes(item.template)}"
          >{{ item.name }}</span>
        </template>
      </div>
    </div>

    <CustomVolumnDiscountBaseOnTag></CustomVolumnDiscountBaseOnTag>

    <CustomPeronalization v-if="isCustomForm || customPersonalization">
      <ProductUpsell />
    </CustomPeronalization>

    <template v-else-if="isLeverSphereCustomizer">
      <client-only>
      <LeverSphereCustomizer
        v-if="isLeverSphereCustomizer"
        ref="leverSphereCustomizerRef"
        @add-to-cart="onPreviewAddToCart"
      />
      </client-only>
    </template>
    <Customization
      v-else-if="isPersonalize && showCustomilyPersonalizeAI"
      @add-to-cart="onPreviewAddToCart"
    >
      <ProductUpsell />
    </Customization>
    <ProductUpsell v-else class="mt-md" />

      <GreetingCardBox
        v-if="
          isGreetingCardFlow &&
          !isProductTypeGreetingCard &&
          !isProductTypeGreetingCardInLineItems
        "
        class="mt-sm"
      />

    <client-only>
      <ProductDonateOptions
        v-if="(donationCode || kolCampaignCode) && !isRestricLocation"
        class="mt-sm"
      />
      <ProductExtra />

    <div class="product__option" v-if="product">
      <h2>Quantity</h2>
      <div :class="{ 'd-flex-wrapper': productStore.isUILandingProduct }">
        <Quantity
          base-class="product"
          :quantity="quantity"
          @update="updateQuantity"
        ></Quantity>
        <ProductFormButton
          v-if="productStore.isUILandingProduct"
          :loading-add-to-cart="loadingAddToCart"
          @add-to-cart="onAddToCart"
          @buy-now="onBuyNow"
        ></ProductFormButton>
      </div>
    </div>
    <div class="product__option" v-else>
      <h2>
        <sib-skeleton-loading width="5em"></sib-skeleton-loading>
      </h2>
      <div class="product__option-choices">
        <sib-skeleton-loading width="7em" height="2em"></sib-skeleton-loading>
      </div>
    </div>

    <div
      v-if="
        (!isExpressShippingChina &&
          isExpressShipping &&
          (!productStore.selectedShippedOption ||
            productStore.selectedShippedOption == US_COUNTRY_CODE)) ||
        (isExpressShippingChina &&
          productStore.selectedShippedOption != US_COUNTRY_CODE)
      "
      class="express-shipping mt-md"
    >
      <div>
        <ul v-if="isExpressShippingChina">
          <li>
            During the Holiday Season, <b>Express Shipping</b> will be
            <b>FASTER</b> than Standard Shipping by <b>3 - 10 days</b>
          </li>
        </ul>
        <div>
          <label for="express-shipping" class="custom-checkbox">
            <input
              class="custom-checkbox__input"
              type="checkbox"
              id="express-shipping"
              v-model="isExpressShippingAdded"
            />
            <CustomCheckbox />
            <span class="ml-xs"
              >Express Shipping<span v-if="expressShippingPrice"
                >: An additional ${{ expressShippingPrice }} will be added to
                the shipping fee at checkout (physical address only, PO box
                address can not be used)
              </span></span
            >
          </label>
        </div>
        <div class="product__small-label" @click="showShippedFromPopup">
          See Estimated Shipping Time Difference
        </div>
        <input
          type="hidden"
          :name="`properties[${EXPRESS_SHIPPING_ATTRIBUTE_KEY}]`"
          :value="isExpressShippingAdded"
        />
        <input
          type="hidden"
          :name="`properties[${EXPRESS_SHIPPING_PRICE_ATTRIBUTE_KEY}]`"
          :value="expressShippingPrice"
        />
      </div>
    </div>
      <ProductShippedFromPopup
        ref="shippedFromPopup"
        class="hidden"
        showExpressShipping
      ></ProductShippedFromPopup>

    <!-- Tạm thời tắt progress bar của chiến dịch Buy more save more -->
    <!-- <template v-if="discountStore.discountProgress">
      <DiscountProgressBarComponent></DiscountProgressBarComponent>
    </template> -->

    <div class="mt-md" v-if="!productStore.isUILandingProduct">
      <ProductFormButton
        :loading-add-to-cart="loadingAddToCart"
        @add-to-cart="onAddToCart"
        @buy-now="onBuyNow"
      ></ProductFormButton>
    </div>
    <!-- <ProductCombo
      v-if="showProductCombo"
      @hidden-cart-popup="hiddenCartPopup = $event"
    /> -->
      <ProductComboNoPreview v-if="product && showProductUpSell" />
    </client-only>
  </form>
</template>

<script setup lang="ts">
import {
  computed,
  defineAsyncComponent,
  onMounted,
  ref,
  onUnmounted,
  watch,
} from 'vue'
import CustomVolumnDiscountBaseOnTag from './CustomVolumnDiscountBaseOnTag.vue'
// import ProductCombo from './ProductCombo.vue'
import ProductComboNoPreview from './ProductComboNoPreview.vue'
import ProductOptions from './ProductOptions.vue'
import LeverSphereProductOptions from './LeverSphereProductOptions.vue'
import ProductExtra from './ProductExtra.vue'

import Quantity from '@/components/product/Quantity.vue'
import GreetingCardBox from '@/components/product/GreetingCardBox.vue'
import ProductFormButton from './ProductFormButton.vue'
import ProductSameDesign from './ProductSameDesign.vue'
import useProductStore from '@/store/product'
import { CartLineItemInput } from '@/provider/type'
import useCartStore from '@/store/cart'
import useSettingStore from '@/store/setting'
import EventBus from '@/services/eventbus'
import {
  CAMPAIGN_DISCOUNT_LINE_ITEM_ATTRIBUTE_KEY,
  PRODUCT_TAG_COMBO_PACK_MULTI_PERSONALIZE,
  EVENT_ADD_TO_CART,
  EVENT_VALIDATE_ATC,
  EVENT_FETCH_CUSTOMIZATION_TEMPLATES_BY_CODE,
  EVENT_INCREASE_AI_TRANSFER_LIMITED,
  EVENT_BUY_NOW,
  EVENT_TRACKING_PRODUCT_ADDED,
  EVENT_TRACKING_BUTTON_ADD_TO_CART_CLICKED,
  EVENT_TRACKING_CLICK_ADD_TO_CART_ON_PREVIEW,
  EVENT_TRACKING_BUTTON_BUY_NOW_CLICKED,
  CURRENCY,
  FIRST_UTM_LINE_ITEM_ATTRIBUTE_KEY_PREFIX,
  LAST_UTM_LINE_ITEM_ATTRIBUTE_KEY_PREFIX,
  LINE_ITEM_PREVIEW_IMAGE_ATTRIBUTE,
  LINE_ITEM_PRODUCTION_IMAGE_ATTRIBUTE,
  CUSTOMILY_PRODUCT_ADDED_ERROR,
  AB_TEST_LINE_ITEM_ATTRIBUTE_KEY,
  MIXPANEL_DESTINATION,
  destinationIntegrations,
  GOOGLE_BUSINESS_VERTICAL,
  PRODUCT_TYPE_GREETING_CARD,
  CUSTOMIZE_EACH_PAGE_TITLE,
  EVENT_ERROR_FILL_OUT_ALL_PAGE_PHOTO_ALBUM,
  PRODUCT_TYPE_QR_GREETING_CARD,
  getCurrentTimeStamp,
  EVENT_ADD_TO_CART_DIGITAL_CONTENT_PRODUCT_FALSE,
  PRODUCT_TAG_CUSTOM_PHOTO_ALBUM,
  PRODUCT_TAG_GOOGLE_DUP_KW,
  PRODUCT_TAG_SHOW_UPSELL_BLOCK,
  PRODUCT_TAG_EXPRESS_SHIPPING_PREFIX,
  US_COUNTRY_CODE,
  VN_COUNTRY_CODE,
  CHINA_COUNTRY_CODE,
  EXPRESS_SHIPPING_ATTRIBUTE_KEY,
  EXPRESS_SHIPPING_PRICE_ATTRIBUTE_KEY,
  PRODUCT_ID_TRACKING_BASE_ONE_PRODUCT_VARIANT_SKU,
  CACHE_KEY_DISCOUNT_CODE,
  SEVEN_DAYS_IN_MILLISECONDS,
  EVENT_UPDATE_QUANTITY,
  DEFAULT_PRICE_TAG_DISCOUNT_LINE_ITEM_ATTRIBUTE_KEY,
  PRODUCT_TAG_EXPRESS_SHIPPING_CHINA,
  PRODUCT_HANDLE_CAMP_WIN,
  EVENT_ADD_TO_CART_COMBO_STATUS,
  PRODUCT_COMBO_HANDLE_ATTRIBUTE_KEY,
  EVENT_CUSTOMILY_DONE_LOADING,
  PRODUCT_TAG_APPLY_FAKE_PRICE_BF9_BUT_NO_DISCOUNT,
  EVENT_UPDATE_GIFT_BOX_EXTRA,
  EVENT_UPDATE_GREETING_CARD_EXTRA,
  PRODUCT_PACK,
  UPSIZE_BASE_PRICE,
  PRODUCT_TAG_FREE_UPSIZE,
  OPTION_TYPE_SIZE,
  SHIPPING_CALCULATION,
  SELECTED_VARIANT_TITLE_ATTRIBUTE_KEY,
  SHIPPING_FEE_PRICE_ATTRIBUTE_KEY,
  TIME_ATC_UPSELL_WITH_GREETING_CARD,
  SKU_PRODUCT_UPSELL_WITH_GREETING_CARD,
} from '@/utils'
import Customization from './Customization.vue'
import CustomPeronalization from './CustomPeronalization.vue'
import LeverSphereCustomizer from './LeverSphereCustomizer.vue'
import { isCampaignIgnoreFreeUpsize } from '@/utils/constants/discount'
import { getFreeUpsizeBasePrice } from '@/utils/freeUpsize'
import useDiscountStore from '@/store/discount'
import Analytics, { UTM } from '@/services/analytics'
import {
  getRawIdFromShopifyId,
  getCustomPersonalization,
  standardizeCartIdFromShopifyId,
  isPersonalizeProduct,
  isProductHasTags,
  extractProductSKUFromHandle,
  isProductHasType,
  buildProductUrl,
  isProductHasTypeStartWith,
} from '@/utils/product'
import Logger from '@/services/log'
import useABTestStoreV2 from '@/composables/abtest/store'
import useMediaCampaignStore from '@/store/media'
import useCustomizationStore from '@/store/customization'
import LocationService from '@/services/location'
import Provider from '@/provider'
import { useRouter } from 'vue-router'
import { useQrGreetingCardAndDigitalContent } from './composables/useQrGreetingCardAndDigitalContent'
import ProductShippedFromPopup from './ProductShippedFromPopup.vue'
import { isProductHasTagStartWith } from '@/utils/product'
import useRequestLocationStore from '@/store/requestLocation'
import CustomCheckbox from '@/assets/images/icons/custom-checkbox.svg'
import CacheService from '@/services/cache'
import useDiscount from '@/composables/applyDiscount'
import { useProductCombo } from './composables/useProductCombo'
import CustomizationIpBlocked from './CustomizationIpBlocked.vue';
import { useIpStore } from '@/store/ip';

const DiscountProgressBarComponent = defineAsyncComponent(
  () => import('@/components/DiscountProgressBar.vue')
)

const ProductDonateOptions = defineAsyncComponent(
  () => import('./ProductDonateOptions.vue')
)

const ProductUpsell = defineAsyncComponent(() => import('./ProductUpsell.vue'))

const customizationStore = useCustomizationStore()
const { getLineItemIdNeedUpdateComboAttribute, getCombosActive } =
  useProductCombo()
const { applyDiscount } = useDiscount()
const router = useRouter()
const mediaCampaignStore = useMediaCampaignStore()
const productStore = useProductStore()
const props = withDefaults(
  defineProps<{
    loading?: boolean
  }>(),
  {
    loading: false,
  }
)

const isLoading = computed(() => props.loading || customizationStore.loading)
const cartStore = useCartStore()
const discountStore = useDiscountStore()
const settingStore = useSettingStore()
const abtestStore = useABTestStoreV2()
const { checkQrGreetingaCardAndDigitalContent } =
  useQrGreetingCardAndDigitalContent()
const quantity = ref(1)
const minQuantity = 1
const maxQuantity = 1000
const loadingAddToCart = ref(false)
const product = computed(() => productStore.product)
const form = ref<HTMLFormElement | null>(null)
const leverSphereCustomizerRef = ref<any>(null)
const lastUTM = ref<UTM | null>(null)
const firstUTM = ref<UTM | null>(null)
const ADD_TO_CART_TYPE = 1
const BUY_NOW_TYPE = 2
let addCartType: typeof ADD_TO_CART_TYPE | typeof BUY_NOW_TYPE =
  ADD_TO_CART_TYPE
const hiddenCartPopup = ref(false)
const addToCartClicked = ref(false)
const lineItemProductGiftBoxExtra = ref(null)
const lineItemProductGreetingCardExtras = ref([])

const isRestricLocation = ref(false)
const requestLocation = useRequestLocationStore()
const isExpressShippingAdded = ref(false)
const shippedFromPopup = ref<typeof ProductShippedFromPopup | null>(null)

const hasFakePriceBF9ButNoDiscountProductTag = isProductHasTags(product.value, [
  PRODUCT_TAG_APPLY_FAKE_PRICE_BF9_BUT_NO_DISCOUNT,
])

const SHIP_FROM_OVERSEAS = 'Overseas'

const productUpSellHandle =
  'nightmare-personalized-nightmare-accent-mug-12471023001scl1tmm1th06ha07an01acm1jak7028'

const showProductUpSell = computed(
  () => productStore.product?.handle == productUpSellHandle
)

const productOptionsExtra = computed(() => {
  // console.log('settingStore.baseProductPage?.productOptionsExtraSettings', settingStore.baseProductPage)
  if (!settingStore.baseProductPage?.productOptionsExtraSettings?.length) {
    return false
  }
  const productOptions =
    settingStore.baseProductPage?.productOptionsExtraSettings.find((item: any) => item.handle == productStore?.product?.handle)
  return productOptions
})

const productOptionsAI = computed(() => {
  const customStyleTransfer = isProductHasTags(productStore.product, [
    settingStore.shop?.productStyleTransferTag || '',
  ])
  if (!customStyleTransfer || (
    !isProductHasTags(productStore.product, ['AI_removebg']) &&
    !isProductHasTags(productStore.product, ['AI_QRMusic']) &&
    !isProductHasTags(productStore.product, ['AI_Music']) &&
    !isProductHasTags(productStore.product, ['AI_video'])
  )) return
  if (!settingStore.baseProductPage?.productOptionsAISettings?.length) return
  const productOptions =
    settingStore.baseProductPage?.productOptionsAISettings.find((item: any) => item.handle == productStore?.product?.handle)
  return productOptions
})

const showProductCombo = computed(() => {
  const comboActive = getCombosActive()
  return comboActive.length > 0
})

const firstProductVariant = computed(() => {
  const selectedVariant = product.value?.variants?.length
    ? product.value?.variants[0]
    : null
  if (!selectedVariant) return

  const productVariant = {
    product_id: isTrackingProductIdBaseOnVariantSku.value
      ? isProductHasTags(product.value, [PRODUCT_TAG_GOOGLE_DUP_KW])
        ? getRawIdFromShopifyId(product.value.id) + '-' + selectedVariant?.sku
        : selectedVariant?.sku
      : +getRawIdFromShopifyId(product.value.id),
    sku: selectedVariant.sku,
    name: product.value.title,
    variant: getRawIdFromShopifyId(selectedVariant.id),
    price: selectedVariant.price,
    quantity: quantity.value,
  }
  return JSON.stringify(productVariant)
})

const isDefaultVariant = computed(() => {
  if (!product.value?.variants?.length) return false
  const firstVariant = product.value?.variants[0]
  if (firstVariant && selectedVariant.value) {
    return firstVariant.id == selectedVariant.value.id
  }
  return false
})
const firstProductVariantPriceTagDiscountCode = computed(() => {
  if (!product.value?.variants?.length) return 0
  const firstProductVariant = product.value.variants[0]
  if (!firstProductVariant) return 0

  if (
    discountStore.tagDiscountCode &&
    discountStore.tagDiscountCodeApplication &&
    isProductHasTags(product.value, [discountStore.tagDiscountCode])
  ) {
    return discountStore.applyTagDiscountCode(
      product.value,
      firstProductVariant.priceV2?.amount || 0,
      firstProductVariant.compareAtPriceV2?.amount || 0,
      firstProductVariant
    )?.price
  }
  return firstProductVariant.price
})

const isTrackingProductViewedSuffixId = computed(() => {
  if (!product.value) return false
  const productHandleItem =
    settingStore.baseProductPage?.productViewedTrackingSetting?.productHandles?.find(
      (item: string) => item == product.value?.handle
    )
  if (productHandleItem) return true
  return false
})

const suffixIdTypes = computed(() => {
  return (
    settingStore.baseProductPage?.productViewedTrackingSetting?.suffixIdType ||
    []
  )
})

const showSameDesign = computed(() => {
  if (productStore.isUILandingProduct) return false
  const productHandlesHiddenSameDesign =
    settingStore.baseProductPage?.productHandlesHiddenSameDesign || []
  if (product.value && productHandlesHiddenSameDesign.length) {
    return !productHandlesHiddenSameDesign.includes(product.value.handle)
  }
  return true
})

const isGreetingCardFlow = computed(() => mediaCampaignStore.greetingCardFlow)

const kolCampaignCode = computed(() => mediaCampaignStore.kolCampaignCode)
const donationCode = computed(() => mediaCampaignStore.donationCode)

const customPersonalization = computed(() => {
  const customPersonalizations =
    settingStore.baseProductPage?.customPersonalizations
  return getCustomPersonalization(productStore.product, customPersonalizations)
})

// check product is Greeting Card type
const isProductTypeGreetingCard = computed(() => {
  return isProductHasType(productStore.product, [PRODUCT_TYPE_GREETING_CARD])
})

// check product is QR Greeting Card type
const isQrGreetingCardProductType = computed(() => {
  return isProductHasType(productStore?.product, [
    PRODUCT_TYPE_QR_GREETING_CARD,
  ])
})
const isDigitalContentProductType = computed(() => {
  return isProductHasTypeStartWith(productStore?.product, 'digital')
})

const qrGreetingCardItemIdBundle = computed(() => {
  const lineItemsQrGreetingCardAndDigitalContent =
    checkQrGreetingaCardAndDigitalContent()

  if (lineItemsQrGreetingCardAndDigitalContent.length) {
    const lineItemsQrGreetingCardNeedDelete =
      lineItemsQrGreetingCardAndDigitalContent.filter(
        (item) => item.type == PRODUCT_TYPE_QR_GREETING_CARD && item.isDelete
      )
    const qrGreetingCardIds = lineItemsQrGreetingCardNeedDelete.map((item) =>
      Number(item.lineItemId.split('?')[0].split('/').pop())
    )
    const lastLineItemQrGreetingCardNeedDelete =
      lineItemsQrGreetingCardNeedDelete.find((item) =>
        item.lineItemId.includes(Math.max(...qrGreetingCardIds).toString())
      )
    if (lastLineItemQrGreetingCardNeedDelete)
      return lastLineItemQrGreetingCardNeedDelete.lineItemId
  }
  return ''
})

const isProductTypeGreetingCardInLineItems = computed(() => {
  const index = cartStore.localCartLineItems.findIndex((lineItem) =>
    isProductHasType(lineItem?.merchandise?.product, [
      PRODUCT_TYPE_GREETING_CARD,
    ])
  )
  return index != -1
})

const isCustomPhotoAlbum = computed(() =>
  isProductHasTags(productStore.product, [PRODUCT_TAG_CUSTOM_PHOTO_ALBUM])
)

const isCustomForm = computed(() => {
  return isProductHasTags(productStore.product, [
    settingStore.shop?.productTagCustomForm || '',
  ])
})

const showUpsellBlock = computed(() => {
  return isProductHasTags(productStore.product, [PRODUCT_TAG_SHOW_UPSELL_BLOCK])
})

const isPersonalize = computed(() => {
  return isPersonalizeProduct(
    productStore.product,
    settingStore.shop?.productTagPersonalize || ''
  )
})

const isLeverSphereCustomizer = computed(() => {
  return !!productStore.productTemplateConfig && isProductHasTags(productStore.product, ['leversphere_customizer'])
})

//hide product customily personalize with AI for IP VN & CHINA
const showCustomilyPersonalizeAI = computed(() => {
  const countryCode = requestLocation.countryCode || LocationService.location?.country_code
  if (!countryCode) return true

  const upperCountry = countryCode.toUpperCase()
  const isBlockedCountry = upperCountry === VN_COUNTRY_CODE.toUpperCase() || CHINA_COUNTRY_CODE.includes(upperCountry)

  if (
    isBlockedCountry &&
    (
      isProductHasTags(productStore.product, ['AI_removebg']) ||
      isProductHasTags(productStore.product, ['AI_QRMusic']) ||
      isProductHasTags(productStore.product, ['AI_Music']) ||
      isProductHasTags(productStore.product, ['AI_video'])
    )
  ) {
    return false
  }

  return true
})

/*
const assignedABTest = computed(() =>
  abtestStore.assignedABTests
    ?.map((abtest) => `${abtest.code}-${abtest.assignedVariant?.code}`)
    .join(',')
)
*/
const assignedABTest = computed(() => {
  if (abtestStore.isReady && abtestStore.output?.inTest && abtestStore.code && abtestStore.variant) {
    return `${abtestStore.code}-${abtestStore.variant}`
  }
  return ''
})

const isTruncatedVariantSKU = computed(() => {
  if (product.value && product.value.handle) {
    const skuFromHandle = extractProductSKUFromHandle(product.value.handle)
    return (
      settingStore.shop?.googleProductSKUsFromHandle
        ?.split(',')
        .includes(skuFromHandle) || false
    )
  }
  return false
})

const selectedVariant = computed(() => productStore.selectedVariant)
const discountApplied = computed(() => {
  if (!product.value) return null
  if (!selectedVariant.value) return null
  return discountStore.applyDiscount(
    product.value,
    selectedVariant.value.priceV2?.amount || 0,
    selectedVariant.value.compareAtPriceV2?.amount || 0,
    selectedVariant.value.sku
  )
})

const isTrackingProductIdBaseOnVariantSku = computed(() => {
  return (
    settingStore.shop?.productTrackingProductIdBaseOn ==
    PRODUCT_ID_TRACKING_BASE_ONE_PRODUCT_VARIANT_SKU
  )
})

const isExpressShipping = computed(() => {
  return (
    isProductHasTagStartWith(
      productStore.product,
      PRODUCT_TAG_EXPRESS_SHIPPING_PREFIX
    ) &&
    requestLocation.countryCode?.toLowerCase() == US_COUNTRY_CODE.toLowerCase()
  )
})

const expressShippingPrice = computed(() => {
  let price = 0
  let finalPrice = 0
  const productTags = productStore.product?.tags
  if (!productTags?.length) return price
  const expressShippingTag = productTags.find((tag) =>
    tag.startsWith(PRODUCT_TAG_EXPRESS_SHIPPING_PREFIX)
  )
  if (!expressShippingTag) return price

  price = +expressShippingTag.split('_').slice(-1)

  if (isNaN(price)) return 0
  if (price % 100 == 0) {
    finalPrice = +(price / 100).toFixed(0)
  } else {
    finalPrice = +(price / 100).toFixed(2)
  }
  if (remoteAreaFeeExpressShipping.value > 0) {
    finalPrice += remoteAreaFeeExpressShipping.value
  }
  return finalPrice
})

const isExpressShippingChina = computed(() => {
  return (
    isProductHasTagStartWith(
      productStore.product,
      PRODUCT_TAG_EXPRESS_SHIPPING_PREFIX
    ) &&
    hasExpressShippingChinaProductTag.value &&
    requestLocation.countryCode?.toLowerCase() == US_COUNTRY_CODE.toLowerCase()
  )
})

const hasExpressShippingChinaProductTag = computed(() => {
  return isProductHasTags(productStore.product, [
    PRODUCT_TAG_EXPRESS_SHIPPING_CHINA,
  ])
})

const remoteAreaFeeExpressShipping = ref(0)

async function showShippedFromPopup() {
  if (!shippedFromPopup.value) return
  shippedFromPopup.value.show()
}
const locationStateCode = ref('')

onMounted(() => {
  EventBus.on(
    EVENT_UPDATE_GIFT_BOX_EXTRA,
    (value) => (lineItemProductGiftBoxExtra.value = value)
  )
  EventBus.on(
    EVENT_UPDATE_GREETING_CARD_EXTRA,
    (value) => (lineItemProductGreetingCardExtras.value = value)
  )

  EventBus.on(EVENT_CUSTOMILY_DONE_LOADING, () => {
    if (!showProductUpSell.value) {
      requestAnimationFrame(() => {
      const buttonGroup = document.querySelector(
        '.product__button-group'
      ) as HTMLButtonElement

      if (buttonGroup) {
        buttonGroup.style.display = 'block'
      }
      })
    }
  })

  // LocationService.onLocationReady(() => {
  //   isRestricLocation.value = LocationService.restricLocation
  //   locationStateCode.value = LocationService.location?.region_code as string

  //   const temp = [
  //     'MI',
  //     'IN',
  //     'OH',
  //     'PA',
  //     'NY',
  //     'CT',
  //     'NJ',
  //     'DE',
  //     'MD',
  //     'VA',
  //     'NC',
  //     'SC',
  //     'GA',
  //     'KY',
  //     'WV',
  //     'WI',
  //     'IL',
  //     'MN',
  //     'IA',
  //     'TN',
  //   ]
  //   if (
  //     isExpressShippingChina.value &&
  //     productStore.product?.handle == PRODUCT_HANDLE_CAMP_WIN &&
  //     requestLocation.countryCode == 'US'
  //   ) {
  //     remoteAreaFeeExpressShipping.value = 7 // Additional shipping fee is 8 dollars
  //   } else if (
  //     locationStateCode.value &&
  //     isExpressShipping.value &&
  //     !temp.includes(locationStateCode.value) &&
  //     !hasExpressShippingChinaProductTag.value
  //   ) {
  //     remoteAreaFeeExpressShipping.value = 10 // Additional shipping fee is 8 dollars
  //   }
  // })
  // get UTM of current user
  Analytics.excuteOnReady(async () => {
    const currentUtms = await Analytics.getCurrentUTMs()
    if (currentUtms && currentUtms.length) {
      lastUTM.value = currentUtms[currentUtms.length - 1]
      firstUTM.value = currentUtms[0]
    }
  })
  window.addEventListener('pageshow', onPageShow)

  EventBus.on(EVENT_UPDATE_QUANTITY, updateQuantityFromProductionOptionsPopup)
})

function updateQuantityFromProductionOptionsPopup(number: number) {
  quantity.value = +number
}

onUnmounted(() => {
  window.removeEventListener('pageshow', onPageShow)
  EventBus.off(EVENT_UPDATE_QUANTITY, updateQuantityFromProductionOptionsPopup)
})

function onPageShow(event: PageTransitionEvent) {
  // when the page is restore from bfcache (click back button)
  // clear all loading state
  if (event.persisted) {
    loadingAddToCart.value = false
    Logger.log('Product page', 'Restore page from bfcache', 2)
  }
}

function updateQuantity(type: string) {
  if (type === 'minus') {
    quantity.value--
  } else if (type === 'plus') {
    quantity.value++
  }
  if (quantity.value < minQuantity) {
    quantity.value = minQuantity
  } else if (quantity.value > maxQuantity) {
    quantity.value = maxQuantity
  }
}

// check user fill out all data for pages of photo album for product has tag custom_photo_album
function checkFilloutAllPagePhotoAlbum() {
  const findParentElement = () => {
    const parentElements = document.querySelectorAll('.customily_option')
    for (let parent of parentElements) {
      let child = parent.querySelector('.option_name')
      if (
        child &&
        child.textContent &&
        child.textContent.includes(CUSTOMIZE_EACH_PAGE_TITLE)
      ) {
        return parent
      }
    }
    return null
  }

  const result = findParentElement()

  if (result) {
    const numberPagePhotoAlbum =
      result.querySelectorAll('.customily-swatch')?.length

    return mediaCampaignStore.photoAlbum.length >= numberPagePhotoAlbum
  }
  return false
}

async function formSubmit(event?: Event) {
  if (event) {
    event.preventDefault()
  }

  // check product has tag photo album fill out data for all page of photo album
  if (isCustomPhotoAlbum.value) {
    const isFilloutAllPagePhotoAlbum = checkFilloutAllPagePhotoAlbum()
    if (!isFilloutAllPagePhotoAlbum) {
      EventBus.trigger(EVENT_ERROR_FILL_OUT_ALL_PAGE_PHOTO_ALBUM)
      return
    }
  }

  try {
    const isLeverSphereCheck = isLeverSphereCustomizer.value
    const activeCustomizerCheck = leverSphereCustomizerRef.value
    if (isLeverSphereCheck && activeCustomizerCheck?.validate) {
      if (!activeCustomizerCheck.validate()) {
        loadingAddToCart.value = false
        return
      }
    }
  } catch (error) {
    
  }

  async function submitRequest() {
    loadingAddToCart.value = true
    if (form.value) {
      const propertiesSign = 'properties['
      const formData = new FormData(form.value)
      let custom_form_value = {}
      let customer_photos = []
      const mapping_key = new Map()
      mapping_key.set(
        'Write your idea and we will design it for you',
        'customer_idea'
      )
      mapping_key.set('Enter your first name', 'first_name')
      mapping_key.set('Enter your last name', 'last_name')
      mapping_key.set('Enter your email', 'email')
      mapping_key.set('Enter your house number, street', 'house_number')
      mapping_key.set('Enter your apartment, suite', 'apartment')
      mapping_key.set('Enter your city', 'city')
      mapping_key.set('Enter your country', 'country')
      mapping_key.set('Enter your postal code', 'postal_code')
      mapping_key.set('Enter your phone number', 'phone_number')

      for (const entry of formData.entries()) {
        let key = entry[0]
        const value = entry[1]
        if (key.startsWith(propertiesSign)) {
          key = key.split(propertiesSign).pop()?.split(']').shift() || ''
          if (value instanceof File) {
            continue
          }
          if (key && !key.startsWith('_')) {
            let custom_key = mapping_key.get(key)
            if (custom_key) {
              custom_form_value[[custom_key]] = value
            }
          }

          if (key && key.includes('_sib-image-link Upload your photos')) {
            customer_photos.push(value)
          }
        }
      }
      let product_id = productStore?.product?.id
      let product_handle = productStore?.product?.handle
      let product_sku = productStore?.selectedVariant?.sku
      let variant_title = productStore?.selectedVariant?.title
      let variant_price = productStore?.selectedVariant?.price
      custom_form_value['product_id'] = product_id
      custom_form_value['product_sku'] = product_sku
      custom_form_value['product_handle'] = product_handle
      custom_form_value['variant_title'] = variant_title
      custom_form_value['variant_price'] = variant_price
      custom_form_value['quantity'] = quantity.value
      custom_form_value['customer_photos'] = customer_photos
      const provider = await Provider.getInstance()
      const response = await provider.yourOwnDesign(custom_form_value)
      if (response.success == true) {
        form.value.reset()
      }
      setTimeout(() => {
        loadingAddToCart.value = false
      }, 2000)
    }
  }

  if (event.submitter?.innerText == 'SUBMIT REQUEST') {
    await submitRequest()

    return
  }

  if (isQrGreetingCardProductType.value) {
    const lineItemsQrGreetingCardAndDigitalContent =
      checkQrGreetingaCardAndDigitalContent()

    if (lineItemsQrGreetingCardAndDigitalContent.length) {
      const lineItemsNeedRemove =
        lineItemsQrGreetingCardAndDigitalContent.filter((item) => item.isDelete)
      if (lineItemsNeedRemove.length) {
        for (let i = 0; i < lineItemsNeedRemove.length; i++) {
          await updateCart(0, lineItemsNeedRemove[i].lineItemId)
        }
      }
    }
  } else if (isProductHasTypeStartWith(productStore?.product, 'digital')) {
    const lineItemsQrGreetingCardAndDigitalContent =
      checkQrGreetingaCardAndDigitalContent()

    if (lineItemsQrGreetingCardAndDigitalContent.length) {
      const lineItemsQrGreetingCardNeedDelete =
        lineItemsQrGreetingCardAndDigitalContent.filter(
          (item) => item.type == PRODUCT_TYPE_QR_GREETING_CARD && item.isDelete
        )
      if (lineItemsQrGreetingCardNeedDelete.length == 0) {
        EventBus.trigger(EVENT_ADD_TO_CART_DIGITAL_CONTENT_PRODUCT_FALSE)
        return
      }
      const qrGreetingCardIds = lineItemsQrGreetingCardNeedDelete.map((item) =>
        Number(item.lineItemId.split('?')[0].split('/').pop())
      )
      const lineItemsQrGreetingCardNeedRemove =
        lineItemsQrGreetingCardNeedDelete.filter(
          (item) =>
            !item.lineItemId.includes(Math.max(...qrGreetingCardIds).toString())
        )

      const lineItemsDigitalContentNeedRemove =
        lineItemsQrGreetingCardAndDigitalContent.filter(
          (item) => item.type == 'Digital Content' && item.isDelete
        )

      if (lineItemsDigitalContentNeedRemove.length) {
        for (let i = 0; i < lineItemsDigitalContentNeedRemove.length; i++) {
          await updateCart(0, lineItemsDigitalContentNeedRemove[i].lineItemId)
        }
      }
      if (lineItemsQrGreetingCardNeedRemove.length) {
        for (let i = 0; i < lineItemsQrGreetingCardNeedRemove.length; i++) {
          await updateCart(0, lineItemsQrGreetingCardNeedRemove[i].lineItemId)
        }
      }
    } else {
      EventBus.trigger(EVENT_ADD_TO_CART_DIGITAL_CONTENT_PRODUCT_FALSE)
      return
    }
  }

  // update attribute for product combo
  if (productStore.productComboSelected) {
    const [lineItemNeedUpdateAttribute, productComboHandleAttribute] =
      getLineItemIdNeedUpdateComboAttribute()

    if (lineItemNeedUpdateAttribute) {
      const attributes = lineItemNeedUpdateAttribute.attributes.map(
        (item: any) => ({
          key: item.key,
          value:
            item.key == PRODUCT_COMBO_HANDLE_ATTRIBUTE_KEY
              ? productComboHandleAttribute
              : item.value,
        })
      )

      const lineItemIdNeedUpdateComboAttribute = lineItemNeedUpdateAttribute.id
      const timeStamp = getCurrentTimeStamp()
      const input = {
        id: lineItemIdNeedUpdateComboAttribute,
        attributes: JSON.parse(JSON.stringify(attributes)),
        timeStamp,
      }
      await cartStore.updateAttributeCartLine(input)
    }
  }

  EventBus.trigger(EVENT_VALIDATE_ATC, { quantity: quantity.value })

  loadingAddToCart.value = true
  
  let response = null
  const isLeverSphere = isLeverSphereCustomizer.value
  const activeCustomizer = leverSphereCustomizerRef.value
  
  if (isLeverSphere && activeCustomizer) {
    const isLoopEnabled = activeCustomizer.isLoopEnabled || false
    const loopCount = activeCustomizer.loopCount || 1
    const preUploadedUrls: Record<number, string> = {}
    try {
      const provider = await Provider.getInstance()
      const uploadPromises = []
      for (let i = 1; i <= loopCount; i++) {
        const details = await activeCustomizer.getPersonalizationDetails(isLoopEnabled ? i : undefined)
        const base64ToUpload = details?.imageOutputCanvasUrl
        if (base64ToUpload && base64ToUpload.startsWith('data:image')) {
          uploadPromises.push((async () => {
            const uploadPromise = provider.uploadImageBase64(base64ToUpload)
            const timeoutPromise = new Promise<string>((_, reject) =>
              setTimeout(() => reject(new Error('Timeout')), 5000)
            )
            try {
              const uploadedUrl = await Promise.race([uploadPromise, timeoutPromise])
              preUploadedUrls[i] = uploadedUrl
            } catch (err) {
              console.warn(`Failed to pre-upload image for item ${i} within 5s limit:`, err)
              preUploadedUrls[i] = details?.imageOutputUrl || details?.imageUploadUrl || 'TIMEOUT_NO_PREVIEW'
            }
          })())
        }
      }
      await Promise.all(uploadPromises)
    } catch (e) {
      console.error('Failed to pre-upload images in parallel:', e)
    }

    for (let i = 1; i <= loopCount; i++) {
      const isLast = i === loopCount
      response = await addToCartV2(isLoopEnabled ? i : undefined, preUploadedUrls[i], !isLast)
    }
  } else {
    response = await addToCart()
  }

  if (isQrGreetingCardProductType.value) {
    // if product has type QR Greeting Card don't show cart popup and redirect to digital product
    setTimeout(() => {
      // go to digital collection after timeout or after event tracking success
      if (selectedVariant.value) {
        const digitalContentSelected =
          selectedVariant.value.selectedOptions?.find((item) =>
            item.name.toLowerCase().includes('digital content')
          )

        if (digitalContentSelected) {
          if (
            digitalContentSelected.value.toLowerCase().includes('comic book')
          ) {
            router.push(
              buildProductUrl(
                'personalized-book-story-comic-style-personalized-digital-comic-book-10001123001scl1cle1mt01cu03ha02dcb1non1007'
              )
            )
          } else if (
            digitalContentSelected.value.toLowerCase().includes('photo book')
          ) {
            router.push(
              buildProductUrl(
                'everyday-neutrals-personalized-digital-photo-book-10011123001scl1cle1mt01th08ha02dpb1non1008'
              )
            )
          } else if (
            digitalContentSelected.value.toLowerCase().includes('slideshow')
          ) {
            router.push(
              buildProductUrl(
                'personalized-book-story-style-personalized-digital-digital-slideshow-11381123001scl1cle1tr04ds02id01dss1non1100'
              )
            )
          }
        }
      }
    }, 500)
  } else {
    // always trigger event add to cart to show cart popup
    if (!hiddenCartPopup.value) {
      EventBus.trigger(EVENT_ADD_TO_CART)
    }

    const isCustomStyleTransfer = computed(() =>
      isProductHasTags(productStore.product, [
        settingStore.shop?.productStyleTransferTag || '',
      ])
    )
    if (isCustomStyleTransfer.value) {
      EventBus.trigger(EVENT_INCREASE_AI_TRANSFER_LIMITED)
    }

    EventBus.trigger(EVENT_ADD_TO_CART_COMBO_STATUS)
    if (productStore.productComboSelected && addToCartClicked.value) {
      productStore.productComboAddByATC = true
    }
  }

  if (addCartType === ADD_TO_CART_TYPE) {
    loadingAddToCart.value = false
  }

  if (!response) return
  const { cart, lineItem } = response

  // trigger event buy now to show loading state of proceed to checkout button
  if (addCartType === BUY_NOW_TYPE) {
    EventBus.trigger(EVENT_BUY_NOW)
  }

  const checkRedirectToCheckout = () => {
    // redirect to checkout page
    if (addCartType === BUY_NOW_TYPE && cart?.checkoutUrl) {
      window.location.href = cart.checkoutUrl
    }
    addCartType = ADD_TO_CART_TYPE
  }

  // check go to checkout page after timeout or after event tracking success
  setTimeout(checkRedirectToCheckout, 500)

  // tracking event add to cart
  if (productStore.product) {
    const product = productStore.product
    const selectedVariant = productStore.product?.variants?.length
      ? productStore.product.variants[0]
      : null // Use the first variant for tracking instead of using selectedVariant
    if (selectedVariant) {
      const is_personalize = isPersonalizeProduct(
        product,
        settingStore.shop?.productTagPersonalize || ''
      )
      const is_cloned_custom = !!getCustomPersonalization(
        product,
        settingStore.baseProductPage?.customPersonalizations
      )
      let item = {
        product_id: isTrackingProductIdBaseOnVariantSku.value
          ? isProductHasTags(product, [PRODUCT_TAG_GOOGLE_DUP_KW])
            ? +getRawIdFromShopifyId(product.id) + '-' + selectedVariant.sku
            : selectedVariant.sku
          : +getRawIdFromShopifyId(product.id),
        sku: selectedVariant.sku,
        name: product.title,
        handle: product.handle,
        url: window.location.href,
        variant: getRawIdFromShopifyId(selectedVariant.id),
        price: selectedVariant.price,
        value: selectedVariant.price,
        quantity: quantity.value,
        customAttributes: lineItem.attributes || [],
        image_url: product.featuredImage?.src,
        type: product.productType,
        tags: product.tags,
        collections: product.collections.map((collection) => collection.title),
        productGid: product.id,
        variantGid: selectedVariant.id,
        variantName: selectedVariant.title,
        is_personalize,
        is_cloned_custom,
        category: product.productType,
      }

      if (discountStore.campaignDiscountCode) {
        item = {
          ...item,
          ...{
            campaign_discount: discountStore.campaignDiscountCode,
            compare_price_discount: discountApplied.value?.compareAtPrice,
            price_discount: discountApplied.value?.price,
          },
        }
      }

      Analytics.track(EVENT_TRACKING_PRODUCT_ADDED, {
        ...item,
        cart_id: standardizeCartIdFromShopifyId(cartStore.cart?.id),
        currency: CURRENCY,
        products: [item],
        items: [
          {
            id: item.product_id,
            name: item.name,
            price: item.price,
            quantity: quantity.value,
            google_business_vertical:
              settingStore.shop?.googleBusinessVertical ||
              GOOGLE_BUSINESS_VERTICAL,
          },
        ],
      })

      if (isTrackingProductViewedSuffixId.value && suffixIdTypes.value.length) {
        let suffixIds: string[] = []
        suffixIdTypes.value.forEach((item: string) => {
          const ids = item.split(',')
          suffixIds = [...suffixIds, ...ids]
        })

        if (suffixIds.length) {
          suffixIds.forEach((suffixId: string) => {
            const productId = Number(`${item.product_id}${suffixId}`)
            Analytics.track(EVENT_TRACKING_PRODUCT_ADDED, {
              ...item,
              product_id: productId,
              cart_id: standardizeCartIdFromShopifyId(cartStore.cart?.id),
              currency: CURRENCY,
              products: [{ ...item, product_id: productId }],
              items: [
                {
                  id: productId,
                  name: item.name,
                  price: item.price,
                  quantity: quantity.value,
                  google_business_vertical:
                    settingStore.shop?.googleBusinessVertical ||
                    GOOGLE_BUSINESS_VERTICAL,
                },
              ],
            })
          })
        }
      }

      if (is_personalize && !is_cloned_custom && lineItem.attributes) {
        const previewAttribute = lineItem.attributes.find(
          (elm) => elm.key == LINE_ITEM_PREVIEW_IMAGE_ATTRIBUTE
        )
        const productionLinkAttribute = lineItem.attributes.find(
          (elm) => elm.key == LINE_ITEM_PRODUCTION_IMAGE_ATTRIBUTE
        )
        if (!previewAttribute?.value || !productionLinkAttribute?.value) {
          // Analytics.track(
          //   CUSTOMILY_PRODUCT_ADDED_ERROR,
          //   {
          //     ...item,
          //     cart_id: standardizeCartIdFromShopifyId(
          //       cartStore.cart?.id
          //     ),
          //     currency: CURRENCY,
          //     products: [item],
          //   },
          //   destinationIntegrations([MIXPANEL_DESTINATION])
          // )
        }
      }
    }
  }

  try {
    if (isLeverSphere) {
      const activeCustomizer = leverSphereCustomizerRef.value
      const details = activeCustomizer?.getPersonalizationDetails?.()
      const leversphereProductionUrlAttr = lineItem.attributes?.find(
        (attr) => attr.key === '_Leversphere-production-url'
      )?.value

      const hasOutputUrlInDetails = !!(details?.imageOutputUrl && String(details.imageOutputUrl).trim())
      const hasProductionUrlInLineItem = !!(leversphereProductionUrlAttr && String(leversphereProductionUrlAttr).trim())

      if (!hasProductionUrlInLineItem || !hasOutputUrlInDetails) {
        Analytics.log(
          'Missing LeverSphere production url or details output url upon Add To Cart',
          {
            productHandle: productStore.product?.handle,
            sku: productStore.selectedVariant?.sku,
            hasProductionUrlInLineItem,
            hasOutputUrlInDetails,
            leversphereProductionUrl: leversphereProductionUrlAttr || '',
            detailsOutputUrl: details?.imageOutputUrl || '',
            detailsUploadUrl: details?.imageUploadUrl || '',
            storeOutputUrl: productStore.productOutputImageUrl || '',
          }
        )
      }
    }
  } catch (error) {
  }
}

function updateCart(quantity: number, id: string) {
  const timeStamp = getCurrentTimeStamp()
  return cartStore.updateCartLine({ id, quantity, timeStamp })
}

async function onAddToCart() {
  addToCartClicked.value = true

  addCartType = ADD_TO_CART_TYPE
  Analytics.track(
    EVENT_TRACKING_BUTTON_ADD_TO_CART_CLICKED,
    {
      product_id: isTrackingProductIdBaseOnVariantSku.value
        ? productStore.product?.variants?.length
          ? isProductHasTags(productStore.product, [PRODUCT_TAG_GOOGLE_DUP_KW])
            ? +getRawIdFromShopifyId(productStore.product?.id) +
              '-' +
              productStore.product?.variants[0]?.sku
            : productStore.product?.variants[0]?.sku
          : ''
        : +getRawIdFromShopifyId(productStore.product?.id),
      cart_id: standardizeCartIdFromShopifyId(cartStore.cart?.id),
      handle: product.value?.handle,
      url: window.location.href,
    },
    destinationIntegrations([MIXPANEL_DESTINATION])
  )
}

async function onBuyNow() {
  addCartType = BUY_NOW_TYPE
  Analytics.track(
    EVENT_TRACKING_BUTTON_BUY_NOW_CLICKED,
    {
      product_id: isTrackingProductIdBaseOnVariantSku.value
        ? productStore.product?.variants?.length
          ? isProductHasTags(productStore.product, [PRODUCT_TAG_GOOGLE_DUP_KW])
            ? +getRawIdFromShopifyId(productStore.product?.id) +
              '-' +
              productStore.product?.variants[0]?.sku
            : productStore.product?.variants[0]?.sku
          : ''
        : +getRawIdFromShopifyId(productStore.product?.id),
      cart_id: standardizeCartIdFromShopifyId(cartStore.cart?.id),
      handle: product.value?.handle,
      url: window.location.href,
    },
    destinationIntegrations([MIXPANEL_DESTINATION])
  )
}

/**
 * Kiểm tra và bù đắp output url cho sản phẩm LeverSphere từ ngọn đến gốc:
 * 1. Ngọn nhất: activeCustomizer.getPersonalizationDetails(packIdx) -> imageOutputUrl
 * 2. Tầng giữa: getEffectivePackPersonalizationValues(packIdx) -> imageOutputUrl
 * 3. Tầng cache: aiStyleTransferRecently -> image
 * 4. Gốc component: Biến được gán trực tiếp khi response trả về từ API: imageUrlOutput (và imageUploadUrl)
 * 5. Tầng global store: productStore (packPreviewImages theo packIdx, hoặc productPreviewImage)
 */
async function ensureLeverSpherePersonalizationOutput(lineItem: CartLineItemInput, packIdx?: number) {
  if (!isLeverSphereCustomizer.value) return
  const activeCustomizer = leverSphereCustomizerRef.value
  if (!activeCustomizer) return

  if (!lineItem.attributes) {
    lineItem.attributes = []
  }

  // 1. Kiểm tra xem trong attributes đã có output url hợp lệ chưa
  const existingOutputAttr = lineItem.attributes.find(
    (attr) => attr.key === '_style-transfer-image-output-url' || attr.key === '_customily-production-url'
  )
  if (existingOutputAttr && existingOutputAttr.value && String(existingOutputAttr.value).trim()) {
    return
  }

  let outputUrl = ''
  let uploadUrl = ''
  let details: any = null
  let stage = 0

  // 1. NGỌN NHẤT: Thử lấy lại từ getPersonalizationDetails
  try {
    details = activeCustomizer.getPersonalizationDetails?.(packIdx)
    if (details?.imageOutputUrl) {
      outputUrl = details.imageOutputUrl
    }
    if (details?.imageUploadUrl) {
      uploadUrl = details.imageUploadUrl
    }
    stage = 1
  } catch (err) {
    console.warn('[LeverSphere Fallback] getPersonalizationDetails failed:', err)
  }

  // 2. TẦNG GIỮA: Thử lấy từ pack personalization values
  if (!outputUrl && typeof activeCustomizer?.getEffectivePackPersonalizationValues === 'function') {
    try {
      const packVals = activeCustomizer.getEffectivePackPersonalizationValues(packIdx || 1)
      if (packVals?.['imageOutputUrl']) {
        outputUrl = packVals['imageOutputUrl']
      }
      if (!uploadUrl && packVals?.['imageUploadUrl']) {
        uploadUrl = packVals['imageUploadUrl']
      }
      stage = 2
    } catch (err) {}
  }

  // 3. TẦNG CACHE: Thử lấy từ lịch sử gần nhất aiStyleTransferRecently
  if (!outputUrl) {
    const recentList = activeCustomizer.aiStyleTransferRecently
    const recent = Array.isArray(recentList) ? recentList[0] : recentList?.value?.[0]
    if (recent) {
      outputUrl = recent.image || recent.imageUploadUrl || ''
      if (!uploadUrl) {
        uploadUrl = recent.imageUploadUrl || ''
      }
    }
    stage = 3
  }

  // 4. GỐC NHẤT Ở COMPONENT: Biến được gán trực tiếp khi response trả về từ API ở component (imageUrlOutput, imageUploadUrl)
  if (!outputUrl) {
    const rootOutput = activeCustomizer.imageUrlOutput?.value ?? activeCustomizer.imageUrlOutput
    if (rootOutput && typeof rootOutput === 'string') {
      outputUrl = rootOutput
    }
    stage = 4
  }
  if (!uploadUrl) {
    const rootUpload = activeCustomizer.imageUploadUrl?.value ?? activeCustomizer.imageUploadUrl
    if (rootUpload && typeof rootUpload === 'string') {
      uploadUrl = rootUpload
    }
  }

  // 5. TẦNG GLOBAL STORE: Ưu tiên URL ảnh output thực tế (HTTP link) từ productStore, tránh dùng base64 gây nặng và lỗi API
  if (!outputUrl) {
    const packOutputs = productStore.packOutputImageUrls
    
    // link HTTP output từ packOutputImageUrls hoặc productOutputImageUrl
    if (packIdx && packOutputs && packOutputs[packIdx - 1]) {
      outputUrl = packOutputs[packIdx - 1]
    } else if (packOutputs && packOutputs.length > 0 && packOutputs[0]) {
      outputUrl = packOutputs[0]
    } else if (productStore.productOutputImageUrl) {
      outputUrl = productStore.productOutputImageUrl
    }
    stage = 5
  }

  try {
  Analytics.track('ensureLeverSpherePersonalizationOutput', {
    stage,
    outputUrl,
    uploadUrl,
    packIdx,
    hasStorePreview: !!productStore.productPreviewImage,
    productPreviewImage: productStore.productPreviewImage || '',
    productOutputImageUrl: productStore.productOutputImageUrl || '',
    attributes: JSON.stringify(lineItem?.attributes || []),
  })
  } catch (error) {
  }

  // Bù đắp lại toàn bộ các trường personalize vào lineItem.attributes
  if (outputUrl || uploadUrl) {
    // Đảm bảo URL cho production là URL CDN/HTTP thực tế, tuyệt đối không dùng base64
    const productionUrl = (outputUrl && !outputUrl.startsWith('data:image'))
      ? outputUrl
      : (productStore.productOutputImageUrl || details?.imageOutputUrl || details?.imageUploadUrl || uploadUrl || '')

    const fallbackAttrs = [
      { key: '_style-transfer-image-upload-url', value: uploadUrl },
      { key: '_style-transfer-image-output-url', value: productionUrl || outputUrl },
      { key: '_customily-thumb-id', value: Math.random().toString() },
      { key: '_customily-preview', value: outputUrl },
      { key: '_customily-thumb', value: outputUrl },
      { key: '_customily-customization-url', value: details?.customizationUrl || window.location.href },
      { key: '_customily-production-url', value: productionUrl || outputUrl },
      { key: '_customily-personalization-id', value: Math.random().toString() },
      { key: '_customily-eps-name', value: Math.random().toString() },
      { key: '_Try With Your Photo', value: productionUrl || outputUrl },
      { key: '_Leversphere-production-url', value: productionUrl || outputUrl },
    ]

    // Xử lý lấy inputNameDetails từ ngọn đến gốc:
    // 1. Ngọn nhất: details.inputNameDetails
    let inputNameDetails = details?.inputNameDetails || ''

    // 2. Tầng giữa: lấy từ packVals kết hợp optionsConfig / customizerSchema
    if (!inputNameDetails) {
      try {
        const packVals = typeof activeCustomizer?.getEffectivePackPersonalizationValues === 'function'
          ? activeCustomizer.getEffectivePackPersonalizationValues(packIdx || 1)
          : null
        const optsList = activeCustomizer.optionsConfig || activeCustomizer.customizerSchema?.options || []

        if (packVals && Array.isArray(optsList) && optsList.length) {
          const nameDetailsMap: Record<string, string> = {}
          optsList.forEach((opt: any) => {
            const val = packVals[opt.name] || ''
            if (val) {
              if (opt.customPromptKey) {
                nameDetailsMap[opt.label || opt.name] = val
              } else if (opt.type === 'InputText' || opt.type === 'TextArea' || opt.type === 'Select') {
                nameDetailsMap[opt.label || opt.name] = val
              }
            }
          })
          if (Object.keys(nameDetailsMap).length) {
            inputNameDetails = JSON.stringify(nameDetailsMap)
          }
        }
      } catch (err) {
        console.warn('[LeverSphere Fallback] Error resolving inputNameDetails from packVals:', err)
      }
    }

    // 3. Tầng Store: Lấy từ productStore.packPersonalizationInputs hoặc productStore.productPersonalizationInputs
    if (!inputNameDetails) {
      try {
        const storePackInputs = productStore.packPersonalizationInputs?.[packIdx || 1] || productStore.productPersonalizationInputs
        const optsList = activeCustomizer.optionsConfig || activeCustomizer.customizerSchema?.options || []
        if (storePackInputs && Array.isArray(optsList) && optsList.length) {
          const nameDetailsMap: Record<string, string> = {}
          optsList.forEach((opt: any) => {
            const val = storePackInputs[opt.name] || ''
            if (val) {
              if (opt.customPromptKey) {
                nameDetailsMap[opt.label || opt.name] = val
              } else if (opt.type === 'InputText' || opt.type === 'TextArea' || opt.type === 'Select') {
                nameDetailsMap[opt.label || opt.name] = val
              }
            }
          })
          if (Object.keys(nameDetailsMap).length) {
            inputNameDetails = JSON.stringify(nameDetailsMap)
          }
        }
      } catch (err) {
        console.warn('[LeverSphere Fallback] Error resolving inputNameDetails from productStore:', err)
      }
    }

    // 4. Nếu lineItem.attributes đã có sẵn _input-details thì tái sử dụng
    if (!inputNameDetails) {
      const existingInputDetailsAttr = lineItem.attributes!.find((a) => a.key === '_input-details')?.value
      if (existingInputDetailsAttr) {
        inputNameDetails = existingInputDetailsAttr
      }
    }

    if (inputNameDetails) {
      fallbackAttrs.push({ key: '_input-details', value: inputNameDetails })
    }
    if (packIdx !== undefined) {
      fallbackAttrs.push({ key: '_pack-item-index', value: String(packIdx) })
    }

    fallbackAttrs.forEach((fAttr) => {
      const idx = lineItem.attributes!.findIndex((attr) => attr.key === fAttr.key)
      if (idx !== -1) {
        if (!lineItem.attributes![idx].value) {
          lineItem.attributes![idx].value = fAttr.value
        }
      } else {
        lineItem.attributes!.push(fAttr)
      }
    })
  }
}

// Free upsize: gắn giá size liền dưới để shopify function tính giảm.
// Thứ tự size lấy theo thứ tự values của option size trên sản phẩm.
// Duyệt từ size liền kề xuống size nhỏ nhất, bỏ qua các size có giá không thấp hơn giá hiện tại,
// lấy size đầu tiên có giá thật sự giảm.
// Luôn gắn thuộc tính để biết đã được đánh giá: không đủ điều kiện (không có size nhỏ hơn, hoặc chênh lệch
// vượt FREE_UPSIZE_MAX_DISCOUNT_PERCENT) thì giá trị bằng giá size đang chọn => function giảm 0.
function addUpsizeBasePriceAttribute(lineItem: CartLineItemInput) {
  try {
    pushUpsizeBasePriceAttribute(lineItem)
  } catch (error) {
    // Lỗi thì bỏ qua Free Upsize, vẫn thêm vào giỏ như luồng cũ
  }
}

function pushUpsizeBasePriceAttribute(lineItem: CartLineItemInput) {
  const product = productStore.product
  const current = productStore.selectedVariant
  if (!product || !current || !isProductHasTags(product, [PRODUCT_TAG_FREE_UPSIZE])) return
  // Giỏ có chiến dịch Black Friday thì không áp dụng Free Upsize
  if (isCampaignIgnoreFreeUpsize(discountStore.campaignDiscountCode)) return

  const currentPrice = Number(current.priceV2?.amount || 0)
  if (!currentPrice) return

  // Đủ điều kiện (chênh lệch <= 15%) thì lấy giá size liền dưới, không thì bằng giá size đang chọn
  const basePrice = getFreeUpsizeBasePrice(product, current) ?? currentPrice

  lineItem.attributes!.push({ key: UPSIZE_BASE_PRICE, value: basePrice.toFixed(2) })
}

async function addToCart() {
  if (!productStore.selectedVariant) return
  const lineItem: CartLineItemInput = {
    merchandiseId: productStore.selectedVariant.id,
    quantity: quantity.value,
    attributes: [],
  }
  if (form.value) {
    const propertiesSign = 'properties['
    const formData = new FormData(form.value)
    for (const entry of formData.entries()) {
      let key = entry[0]
      const value = entry[1]
      if (key.startsWith(propertiesSign)) {
        key = key.split(propertiesSign).pop()?.split(']').shift() || ''
        if (value instanceof File) {
          continue
        }
        if (key) {
          lineItem.attributes!.push({ key, value })
        }
      }
    }
  }
  const isLeverSphere = isLeverSphereCustomizer.value
  const activeCustomizer = leverSphereCustomizerRef.value
  if (isLeverSphere && activeCustomizer) {
    try {
      const details = await activeCustomizer.getPersonalizationDetails()
      if (details) {
        let previewUrl = ''
        const base64ToUpload = details.imageOutputCanvasUrl
        if (base64ToUpload?.startsWith('data:image')) {
          const provider = await Provider.getInstance()
          previewUrl = await provider.uploadImageBase64(base64ToUpload)
        } else if (base64ToUpload?.startsWith('http')) {
          previewUrl = base64ToUpload
        } else {
          previewUrl = details.imageOutputUrl
        }

        const customilyAttrs = [
          { key: '_style-transfer-image-upload-url', value: details.imageUploadUrl },
          { key: '_style-transfer-image-output-url', value: details.imageOutputUrl },
          { key: '_input-details', value: details.inputNameDetails },

          { key: '_customily-thumb-id', value: Math.random().toString() },
          { key: '_customily-preview', value: previewUrl },
          { key: '_customily-thumb', value: previewUrl },
          { key: '_customily-customization-url', value: details.customizationUrl },
          { key: '_customily-production-url', value: details.imageOutputUrl },
          { key: '_customily-personalization-id', value: Math.random().toString() },
          { key: '_customily-eps-name', value: Math.random().toString() },
          { key: '_Try With Your Photo', value: details.imageOutputUrl },

          { key: '_Leversphere-production-url', value: details.imageOutputUrl },

          // { key: '_shipping-calculation', value: '' },
        ]
        if (details.voiceOutputUrl) {
          customilyAttrs.push({ key: '_voice-output-url', value: details.voiceOutputUrl })
        }
        if (details.videoOutputUrl) {
          customilyAttrs.push({ key: '_style-transfer-video-url', value: details.videoOutputUrl })
        }
        lineItem.attributes.push(...customilyAttrs)
      }
    } catch (e) {
      console.error('Failed to upload and add LeverSphere customizer attributes:', e)
    }
  }

  let shippingCalculationAttributes = []
  const isProductPackOptionAttribute = lineItem.attributes.find(
    (item) => item.key == PRODUCT_PACK && item.value == 'true'
  )
  if (isProductPackOptionAttribute) {
    shippingCalculationAttributes = lineItem.attributes.filter((item) =>
      item.key?.toLowerCase()?.includes('_pack')
    )

    shippingCalculationAttributes.push({
      key: SELECTED_VARIANT_TITLE_ATTRIBUTE_KEY,
      value: selectedVariant.value.title,
    })
  }
  const PREFIX_SHIPPING_FEE_TAG = 'shipping_fee_'
  const shippingFeeLineItemTag = product.value.tags.find((item) =>
    item.startsWith(PREFIX_SHIPPING_FEE_TAG)
  )
  if (shippingFeeLineItemTag) {
    shippingCalculationAttributes.push({
      key: SHIPPING_FEE_PRICE_ATTRIBUTE_KEY,
      value: shippingFeeLineItemTag.split(PREFIX_SHIPPING_FEE_TAG)[1],
    })
    lineItem.attributes!.push({
      key: SHIPPING_FEE_PRICE_ATTRIBUTE_KEY,
      value: shippingFeeLineItemTag.split(PREFIX_SHIPPING_FEE_TAG)[1],
    })
  }
  const ANY_CHANGE_VARIANT_IDS: Record<string, string> = {
    "fiverprints.com": "gid://shopify/ProductVariant/51859378536730",
    "siroprints.com": "gid://shopify/ProductVariant/48544404373755",
    "sunflowerly.com": "gid://shopify/ProductVariant/53231917990193",
    "silveryprints.com": "gid://shopify/ProductVariant/45975340843204",
  }

  if (form.value && isProductHasTags(productStore.product, ['charge_any_change'])) {
    const formData = new FormData(form.value)
    const anyChangeValue = formData.get('properties[Any Changes Needed?]')

    const currentDomain = window.location.hostname
    const variantId = ANY_CHANGE_VARIANT_IDS[currentDomain]

    if (anyChangeValue && variantId) {
      await cartStore.addToCart({
        merchandiseId: variantId,
        quantity: 1
      })
    }

  }

  if (isExpressShippingAdded.value) {
    shippingCalculationAttributes.push(
      {
        key: EXPRESS_SHIPPING_ATTRIBUTE_KEY,
        value: isExpressShippingAdded.value,
      },
      {
        key: EXPRESS_SHIPPING_PRICE_ATTRIBUTE_KEY,
        value: expressShippingPrice.value,
      }
    )
  }

  // add attribute to caculate shipping fee at shopify function app
  if (shippingCalculationAttributes.length) {
    lineItem.attributes!.push({
      key: SHIPPING_CALCULATION,
      value: JSON.stringify(shippingCalculationAttributes),
    })
  }

  addUpsizeBasePriceAttribute(lineItem)

  // add timestamp to attributes to know which products were added together
  const timeStampATC = getCurrentTimeStamp()
  if (lineItemProductGreetingCardExtras.value?.length) {
    lineItem.attributes!.push({
      key: TIME_ATC_UPSELL_WITH_GREETING_CARD,
      value: timeStampATC.toString(),
    })
    for (let i = 0; i < lineItemProductGreetingCardExtras.value.length; i++) {
      if (!lineItemProductGreetingCardExtras.value[i].attributes) {
        lineItemProductGreetingCardExtras.value[i].attributes = []
      }
      lineItemProductGreetingCardExtras.value[i]?.attributes?.push({
        key: TIME_ATC_UPSELL_WITH_GREETING_CARD,
        value: timeStampATC.toString(),
      })
      lineItemProductGreetingCardExtras.value[i]?.attributes?.push({
        key: SKU_PRODUCT_UPSELL_WITH_GREETING_CARD,
        value: productStore.selectedVariant?.fullSku || productStore.product?.variants?.[0]?.fullSku || productStore.product?.variants?.[0]?.sku,
      })
      if (firstUTM.value?.id) {
        lineItemProductGreetingCardExtras.value[i]?.attributes?.push({
          key: `${FIRST_UTM_LINE_ITEM_ATTRIBUTE_KEY_PREFIX}id`,
          value: firstUTM.value.id?.toString(),
        })
      }
      if (lastUTM.value?.id) {
        lineItemProductGreetingCardExtras.value[i]?.attributes?.push({
          key: `${LAST_UTM_LINE_ITEM_ATTRIBUTE_KEY_PREFIX}id`,
          value: lastUTM.value.id?.toString(),
        })
      }
    }
  }

  await ensureLeverSpherePersonalizationOutput(lineItem)

  const cart = await cartStore.addToCart(lineItem)

  if (productStore.productsExtra.length && productStore.isUILandingProduct) {
    for (let i = 0; i < productStore.productsExtra.length; i++) {
      const lineItemExtra: CartLineItemInput = {
        merchandiseId: productStore.productsExtra[i].productVariantIdSelected,
        quantity: quantity.value,
        attributes: [],
      }
      await cartStore.addToCart(lineItemExtra)
    }
  }

  if (lineItemProductGiftBoxExtra.value) {
    await cartStore.addToCart(lineItemProductGiftBoxExtra.value)
  }
  if (lineItemProductGreetingCardExtras.value?.length) {
    for (let i = 0; i < lineItemProductGreetingCardExtras.value.length; i++) {
      await cartStore.addToCart(lineItemProductGreetingCardExtras.value[i])
    }
  }

  try {
    if (
      discountStore.googleDiscountCode &&
      !discountStore.googleDiscountApplied
    ) {
      await applyGoogleDiscount()
    }

    // apply discount code
    if (
      discountStore.discountCode &&
      (!cartStore.discountCodeCurrentApply ||
        (discountStore.tagDiscountCode &&
          discountStore.tagDiscountCode?.toLowerCase() !=
            cartStore.discountCodeCurrentApply?.toLowerCase())) &&
      !discountStore.campaignDiscountCode
    ) {
      await cartStore.cartDiscountCodeApply(discountStore.discountCode)
    }
  } catch (error) {
    // do nothing
  }

  return { cart, lineItem }
}

async function addToCartV2(packIdx?: number, preUploadedUrl?: string, skipExtraItems = false) {
  if (!productStore.selectedVariant) {
    return
  }
  let merchandiseId = productStore.selectedVariant.id
  if (packIdx !== undefined && isProductHasTags(productStore.product, [PRODUCT_TAG_COMBO_PACK_MULTI_PERSONALIZE])) {
    const pack1Variant = productStore.product?.variants?.find((variant: any) => {
      return variant.selectedOptions?.every((opt: any) => {
        if (opt.name.toLowerCase() === 'pack') {
          return opt.value.toLowerCase() === 'pack 1'
        }
        const selectedOpt = productStore.selectedVariant?.selectedOptions?.find(
          (so: any) => so.name === opt.name
        )
        return selectedOpt && selectedOpt.value === opt.value
      })
    })
    if (pack1Variant) {
      merchandiseId = pack1Variant.id
    }
  }

  const lineItem: CartLineItemInput = {
    merchandiseId,
    quantity: quantity.value,
    attributes: [],
  }
  if (form.value) {
    const propertiesSign = 'properties['
    const formData = new FormData(form.value)
    for (const entry of formData.entries()) {
      let key = entry[0]
      const value = entry[1]
      if (key.startsWith(propertiesSign)) {
        key = key.split(propertiesSign).pop()?.split(']').shift() || ''
        if (value instanceof File) {
          continue
        }
        if (key) {
          lineItem.attributes!.push({ key, value })
        }
      }
    }
  }
  const isLeverSphere = isLeverSphereCustomizer.value
  const activeCustomizer = leverSphereCustomizerRef.value
  
  if (isLeverSphere && activeCustomizer) {
    try {
      const details = await activeCustomizer.getPersonalizationDetails(packIdx)

      if (details) {
        let previewUrl = ''
        const base64ToUpload = details.imageOutputCanvasUrl
        if (preUploadedUrl && preUploadedUrl !== 'TIMEOUT_NO_PREVIEW') {
          previewUrl = preUploadedUrl
        } else if (base64ToUpload?.startsWith('data:image')) {
          const provider = await Provider.getInstance()
          previewUrl = await provider.uploadImageBase64(base64ToUpload)
        } else if (base64ToUpload?.startsWith('http')) {
          previewUrl = base64ToUpload
        } else {
          previewUrl = details.imageOutputUrl || details.imageUploadUrl || ''
        }

        const customilyAttrs = [
          { key: '_style-transfer-image-upload-url', value: details.imageUploadUrl },
          { key: '_style-transfer-image-output-url', value: details.imageOutputUrl },
          { key: '_input-details', value: details.inputNameDetails },

          { key: '_customily-thumb-id', value: Math.random().toString() },
          { key: '_customily-preview', value: previewUrl },
          { key: '_customily-thumb', value: previewUrl },
          { key: '_customily-customization-url', value: details.customizationUrl },
          { key: '_customily-production-url', value: details.imageOutputUrl || details.imageUploadUrl },
          { key: '_customily-personalization-id', value: Math.random().toString() },
          { key: '_customily-eps-name', value: Math.random().toString() },
          { key: '_Try With Your Photo', value: details.imageOutputUrl || details.imageUploadUrl },

          { key: '_Leversphere-production-url', value: details.imageOutputUrl || details.imageUploadUrl },
        ]
        if (packIdx !== undefined) {
          customilyAttrs.push({ key: '_pack-item-index', value: String(packIdx) })
        }
        if (details.voiceOutputUrl) {
          customilyAttrs.push({ key: '_voice-output-url', value: details.voiceOutputUrl })
        }
        if (details.videoOutputUrl) {
          customilyAttrs.push({ key: '_style-transfer-video-url', value: details.videoOutputUrl })
        }
        lineItem.attributes.push(...customilyAttrs)
      } else {
        try {
          Analytics.track('addToCartV2 - customilyAttrsError', {
            packIdx,
            preUploadedUrl,
            errorMessage: 'No details returned from getPersonalizationDetails',
            attributes: JSON.stringify(lineItem?.attributes || []),
          })
        } catch (error) {
        }
      }
    } catch (e: any) {
      try {
        Analytics.track('addToCartV2 - customilyAttrsError', {
          packIdx,
          errorMessage: e?.message || String(e),
          errorStack: e?.stack || '',
          attributes: JSON.stringify(lineItem?.attributes || []),
          preUploadedUrl: preUploadedUrl || '',
      })
      } catch (error) {
      }
    }
  }

  let shippingCalculationAttributes = []
  const isProductPackOptionAttribute = lineItem.attributes.find(
    (item) => item.key == PRODUCT_PACK && item.value == 'true'
  )
  if (isProductPackOptionAttribute) {
    shippingCalculationAttributes = lineItem.attributes.filter((item) =>
      item.key?.toLowerCase()?.includes('_pack')
    )

    shippingCalculationAttributes.push({
      key: SELECTED_VARIANT_TITLE_ATTRIBUTE_KEY,
      value: selectedVariant.value.title,
    })
  }
  const PREFIX_SHIPPING_FEE_TAG = 'shipping_fee_'
  const shippingFeeLineItemTag = product.value.tags.find((item) =>
    item.startsWith(PREFIX_SHIPPING_FEE_TAG)
  )
  if (shippingFeeLineItemTag) {
    shippingCalculationAttributes.push({
      key: SHIPPING_FEE_PRICE_ATTRIBUTE_KEY,
      value: shippingFeeLineItemTag.split(PREFIX_SHIPPING_FEE_TAG)[1],
    })
    lineItem.attributes!.push({
      key: SHIPPING_FEE_PRICE_ATTRIBUTE_KEY,
      value: shippingFeeLineItemTag.split(PREFIX_SHIPPING_FEE_TAG)[1],
    })
  }
  const ANY_CHANGE_VARIANT_IDS: Record<string, string> = {
    "fiverprints.com": "gid://shopify/ProductVariant/51859378536730",
    "siroprints.com": "gid://shopify/ProductVariant/48544404373755",
    "sunflowerly.com": "gid://shopify/ProductVariant/53231917990193",
    "silveryprints.com": "gid://shopify/ProductVariant/45975340843204",
  }

  if (!skipExtraItems && form.value && isProductHasTags(productStore.product, ['charge_any_change'])) {
    const formData = new FormData(form.value)
    const anyChangeValue = formData.get('properties[Any Changes Needed?]')

    const currentDomain = window.location.hostname
    const variantId = ANY_CHANGE_VARIANT_IDS[currentDomain]

    if (anyChangeValue && variantId) {
      await cartStore.addToCart({
        merchandiseId: variantId,
        quantity: 1
      })
    }

  }

  if (isExpressShippingAdded.value) {
    shippingCalculationAttributes.push(
      {
        key: EXPRESS_SHIPPING_ATTRIBUTE_KEY,
        value: isExpressShippingAdded.value,
      },
      {
        key: EXPRESS_SHIPPING_PRICE_ATTRIBUTE_KEY,
        value: expressShippingPrice.value,
      }
    )
  }

  // add attribute to caculate shipping fee at shopify function app
  if (shippingCalculationAttributes.length) {
    lineItem.attributes!.push({
      key: SHIPPING_CALCULATION,
      value: JSON.stringify(shippingCalculationAttributes),
    })
  }

  addUpsizeBasePriceAttribute(lineItem)

  // add timestamp to attributes to know which products were added together
  const timeStampATC = getCurrentTimeStamp()
  if (packIdx !== undefined) {
    // Để Shopify xem mỗi item trong pack là các sản phẩm khác nhau (không gộp quantity), ta gán id ngẫu nhiên độc lập
    lineItem.attributes!.push(
      { key: '_customily-personalization-id', value: Math.random().toString() },
      { key: '_pack-item-index', value: String(packIdx) }
    )
  }
  if (lineItemProductGreetingCardExtras.value?.length) {
    lineItem.attributes!.push({
      key: TIME_ATC_UPSELL_WITH_GREETING_CARD,
      value: timeStampATC.toString(),
    })
    for (let i = 0; i < lineItemProductGreetingCardExtras.value.length; i++) {
      if (!lineItemProductGreetingCardExtras.value[i].attributes) {
        lineItemProductGreetingCardExtras.value[i].attributes = []
      }
      lineItemProductGreetingCardExtras.value[i]?.attributes?.push({
        key: TIME_ATC_UPSELL_WITH_GREETING_CARD,
        value: timeStampATC.toString(),
      })
      lineItemProductGreetingCardExtras.value[i]?.attributes?.push({
        key: SKU_PRODUCT_UPSELL_WITH_GREETING_CARD,
        value: productStore.selectedVariant?.fullSku || productStore.product?.variants?.[0]?.fullSku || productStore.product?.variants?.[0]?.sku,
      })
      if (firstUTM.value?.id) {
        lineItemProductGreetingCardExtras.value[i]?.attributes?.push({
          key: `${FIRST_UTM_LINE_ITEM_ATTRIBUTE_KEY_PREFIX}id`,
          value: firstUTM.value.id?.toString(),
        })
      }
      if (lastUTM.value?.id) {
        lineItemProductGreetingCardExtras.value[i]?.attributes?.push({
          key: `${LAST_UTM_LINE_ITEM_ATTRIBUTE_KEY_PREFIX}id`,
          value: lastUTM.value.id?.toString(),
        })
      }
    }
  }

  await ensureLeverSpherePersonalizationOutput(lineItem, packIdx)

  const cart = await cartStore.addToCart(lineItem)

  if (!skipExtraItems) {
  if (productStore.productsExtra.length && productStore.isUILandingProduct) {
    for (let i = 0; i < productStore.productsExtra.length; i++) {
      const lineItemExtra: CartLineItemInput = {
        merchandiseId: productStore.productsExtra[i].productVariantIdSelected,
        quantity: quantity.value,
        attributes: [],
      }
      await cartStore.addToCart(lineItemExtra)
    }
  }

  if (lineItemProductGiftBoxExtra.value) {
    await cartStore.addToCart(lineItemProductGiftBoxExtra.value)
  }
  if (lineItemProductGreetingCardExtras.value?.length) {
    for (let i = 0; i < lineItemProductGreetingCardExtras.value.length; i++) {
      await cartStore.addToCart(lineItemProductGreetingCardExtras.value[i])
    }
  }

  try {
    if (
      discountStore.googleDiscountCode &&
      !discountStore.googleDiscountApplied
    ) {
      await applyGoogleDiscount()
    }

    // apply discount code
    if (
      discountStore.discountCode &&
      (!cartStore.discountCodeCurrentApply ||
        (discountStore.tagDiscountCode &&
          discountStore.tagDiscountCode?.toLowerCase() !=
            cartStore.discountCodeCurrentApply?.toLowerCase())) &&
      !discountStore.campaignDiscountCode
    ) {
      await cartStore.cartDiscountCodeApply(discountStore.discountCode)
    }
  } catch (error) {
    // do nothing
  }
  }

  return { cart, lineItem }
}

async function applyGoogleDiscount() {
  await CacheService.instance?.set(
    CACHE_KEY_DISCOUNT_CODE,
    discountStore.googleDiscountCode,
    SEVEN_DAYS_IN_MILLISECONDS
  )
  await applyDiscount()
}

async function onPreviewAddToCart() {
  addToCartClicked.value = true

  const addToCartButton = document.querySelector(
    '.product__button-group .product__add-to-cart-button'
  ) as HTMLButtonElement
  if (product.value) {
    Analytics.track(
      EVENT_TRACKING_CLICK_ADD_TO_CART_ON_PREVIEW,
      {
        product_id: isTrackingProductIdBaseOnVariantSku.value
          ? productStore.product?.variants?.length
            ? isProductHasTags(productStore.product, [
                PRODUCT_TAG_GOOGLE_DUP_KW,
              ])
              ? +getRawIdFromShopifyId(productStore.product?.id) +
                '-' +
                productStore.product?.variants[0]?.sku
              : productStore.product?.variants[0]?.sku
            : ''
          : +getRawIdFromShopifyId(productStore.product?.id),
        cart_id: standardizeCartIdFromShopifyId(cartStore.cart?.id),
        handle: product.value.handle,
        tags: product.value.tags,
        url: window.location.href,
        add_to_cart_button_exists: !!addToCartButton,
      },
      destinationIntegrations([MIXPANEL_DESTINATION])
    )
  }

  if (!addToCartButton) return
  addToCartButton.click()
}

function fetchCustomizationTemplatesByCode(code: string) {
  if(!code) return
  if (customizationStore.customizationTemplates?.[0]?.code?.includes(code)) return
  EventBus.trigger(EVENT_FETCH_CUSTOMIZATION_TEMPLATES_BY_CODE, code)
}


// const isBlockIp = ref(true)
// watchEffect(() => {
//   try {
//     if (!ipStore.checked) return
//     const productSKUs: string[] = [

//     ]
//     const productSKU = productStore.product?.handle
//       ? extractProductSKUFromHandle(productStore.product.handle)
//       : ''
//     const isIncludedProductSKU = productSKUs.includes(productSKU)


//     if (
//       // isIncludedProductSKU &&
//       abtestStoreV2.code === IP_CHECK_CAMPAIGN.code &&
//       abtestStoreV2.variant === abTestGlobalKey.groupTreatment &&
//       !ipStore.isIpValid
//     ) {
//       isBlockIp.value = true
//     } else {
//       isBlockIp.value = false
//     }
//   } catch (error) {
//     isBlockIp.value = false
//   }
// })

const ipStore = useIpStore()
const hasAITag = computed(() => {
  return (
    isProductHasTags(productStore.product, ['AI_removebg']) ||
    isProductHasTags(productStore.product, ['AI_QRMusic']) ||
    isProductHasTags(productStore.product, ['AI_Music']) ||
    isProductHasTags(productStore.product, ['AI_video'])
  )
})
const isTechLeversphereBypass = computed(() => {
  if (typeof window === 'undefined') return false
  return window.localStorage.getItem('tech_leversphere') === 'true'
})
const isBlockedAiFeature = computed(() => {
  if (isTechLeversphereBypass.value) {
    console.log('TechLeversphereBypass')
    return false
  }

  return hasAITag.value &&
  (
    requestLocation.countryCode?.toLowerCase() == VN_COUNTRY_CODE.toLowerCase() || 
    CHINA_COUNTRY_CODE.includes(requestLocation.countryCode?.toUpperCase())
  )
})

// logic dành riêng cho debug
onMounted(() => {
  watch(() => [isBlockedAiFeature.value, hasAITag.value, ipStore.ip, ipStore.countryCode, ipStore.isIpValid], (newVal, oldVal) => {
    // Logger.log('newVal[0]', newVal[0], 0)
    // Logger.log('newVal[1]', newVal[1], 0)
    // Logger.log('newVal[3]', newVal[3], 0)
    // Logger.log('newVal[4]', newVal[4], 0)
  })
})
</script>
